module.exports = __webpack_public_path__ + "static/media/mycial-logo-color.ce876883.svg";